import { render, staticRenderFns } from "./CentersSelect.vue?vue&type=template&id=35fb644c"
import script from "./CentersSelect.vue?vue&type=script&lang=js"
export * from "./CentersSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports